<template>
  <div class="test-card" style="cursor: pointer" @click="CardClick">
    <!-- 是否收藏按钮 -->
    <el-button text bg @click.stop="cancelCollect(props.info)"
      >取消收藏</el-button
    >
    <div class="back-box">
      <slot name="textImg">
        <img :class="props.info.img_type === 2 ? 'bigwidth' : ''" v-complete:src="props.info.img_url" />
      </slot>
    </div>

    <p class="box-price">
      {{ props.info.price === 0 ? "暂无定价" : props.info.price }}
    </p>
    <p class="box-content">
      {{ props.info.title }}
    </p>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
//引入我的收藏列表、取消收藏接口
import { delFavoritesList } from "@/api/personalCenter/myCollection/index.js";
import { ElMessage, ElMessageBox } from "element-plus";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
});

const props = defineProps({
  path: {
    type: String,
    default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
  // 是否跳转到外部页面
  outPage: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['getList'])

// 卡片点击
function CardClick() {
  if (!props.outPage) {
    router.push({
      path: props.path,
      query: {
        id: props.info.id,
      },
    });
  } else {
    if (props.path) {
      window.open(props.path);
    }
  }
}

//取消收藏
function cancelCollect(item) {
  ElMessageBox.confirm("是否取消收藏该条数据？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      // 调用接口
      delFavoritesList(mydata.userInfo.jwt, { favorite_id: item.id }).then(
        (res) => {
          ElMessage({
            message: res.msg,
            type: "success",
          });
          // 查询列表
          // userFavoritesFn();
          emits('getList')
        }
      );
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消操作",
      });
    });
}
</script>

<style scoped lang="scss">
//是否收藏按钮
:deep(.el-button) {
  // width: 68px;
  // height: 26px;
  position: absolute;
  top: 17px;
  right: 17px;
}

.test-card {
  width: 166px;
  // height: 282px;
  background-color: #ffffff;
  padding: 14px;
  border-radius: 8px;

  position: relative;
  //   border: 1px solid blue;
  .back-box {
    // width:192px;
    // display: block;
    width: 100%;
    height: 139px;
    // border:1px solid red;
    border-radius: 8px;
    background-color: #eeeeee;
    overflow: hidden;
    display:flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: 80px;
      // height: 159px;
      margin: 0 auto;
      // margin-top: 15px;
    }
  }

  .box-price {
    font-size: 22px;
    font-weight: 700;
    line-height: 24px;
    color: #ff1a1a;
    margin-top: 14px;
    margin-bottom: 12px;
  }
  //内容样式
  .box-content {
    width: 100%;
    height: 48px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    text-overflow: ellipsis; //文本溢出 用省略号显示
    -webkit-line-clamp: 2; //几行
    overflow: hidden;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    margin-top: 14px;
    // border: 1px solid red;
  }
  .box-content:hover{
    color:#009de0;
  }
}
</style>
